import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEmailSignature } from 'hooks/useEmailSignature';
import { useUserContext } from 'providers/UserProvider';
import strings from 'strings';
import { BulkDrawerFormFieldsMap } from 'UI/components/organisms/BulkEmailForm/fields';

import { getAttemptsFormValues } from '../BulkSequences.utils';
import { INITIAL_BULK_KEY } from '../components/BulkEmailDrawerAttempts/BulkEmailDrawerAttempts.constants';

export const useSequencesPreviewSections = () => {
  const { watch } = useFormContext();
  const [currentUser] = useUserContext();
  const { signature } = useEmailSignature();

  const searchProject = watch(BulkDrawerFormFieldsMap.To.key);
  const subject = watch(BulkDrawerFormFieldsMap.Subject.key);
  const emailBody = watch(BulkDrawerFormFieldsMap.EmailBody.key);
  const attemptsWatchers = getAttemptsFormValues(watch);

  const from = useMemo(
    () => `${currentUser.personalInformation?.full_name ?? ''} - ${currentUser.email}`,
    [currentUser]
  );

  const sections = useMemo(() => {
    const finalSignature = signature || '';
    const initialTo = searchProject ? `${searchProject.name} (${searchProject.bulkableItems})` : '';

    const initialSection = {
      emailBody: `${emailBody}${finalSignature}`,
      from,
      key: INITIAL_BULK_KEY,
      subject,
      to: initialTo
    };
    const attemptsSections = Object.entries(attemptsWatchers || {}).map(([key, attempt]) => ({
      ...attempt,
      emailBody: `${attempt.emailBody}${finalSignature}`,
      from,
      key,
      to: strings.bulkEmails.forms.sequences.preview.searchProjectDefaultLabel
    }));

    return [initialSection, ...attemptsSections];
  }, [attemptsWatchers, emailBody, from, searchProject, signature, subject]);

  return sections;
};
